import React, { useEffect, useMemo, useRef, useState } from "react";
import { DatePicker, Input } from "common/InputForm";
import { CustomButton } from "components/form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import { editProductApi, productDetailApi } from "services/product";
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoCloudUploadOutline } from "react-icons/io5";
import { GoX } from "react-icons/go";
import { masterBrandListApi, masterCategoriesListApi, masterClothingCategoriesListApi, masterColorApi, masterSizeApi } from "services/master";
import Select from "react-select";
import JoditEditor from "jodit-react";
import { regex } from "utils/formValidator";
import { Star } from "utils/text";
import Form from "pages/web-scraped-product/Form";
const EditProduct = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [availableSizes, setAvailableSizes] = useState([]);
  const [paletteName, setPaletteName] = useState([]);
  const [occasionName, setOccasionName] = useState([]);
  const [colorList, setColorList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [sizeList, setSizeList] = useState([]);
  const [showSize, setShowSize] = useState(false)
  const [sizeType, setSizeType] = useState("")
  const [selectedOptions, setSelectedOptions] = useState({
    height: [],
    paletteName: [],
    bodyShape: [],
    styleIdentity: [],
    flauntParts: [],
    downplayParts: [],
    occasionName: [],
    availableSizes: [],
    category: '',
    brand: '',
    colorName: ''
  })
  console.log(paletteName, "paletteName")
  const handleSizeChange = (selectedOptions) => {
    setAvailableSizes(selectedOptions?.map((option) => option.value));
  };
  const handlePaletteChange = (selectedOptions) => {
    setPaletteName(selectedOptions?.map((option) => option.value));
  };
  const occasionArray = [
    { value: "Casual", label: "Casual" },
    { value: "Formal", label: "Formal" },
    { value: "Party", label: "Party" },

  ];
  const handleOccasionChange = (selectedOptions) => {
    setOccasionName(selectedOptions.map((option) => option.value));
    setErrors((prevData) => ({ ...prevData, occasionName: null }));
  };

  const editor = useRef(null);
  // Editor Config
  const config = useMemo(
    () => ({
      readonly: false,
      toolbar: true,
      spellcheck: true,
      placeholder: "",

      language: "en",
      toolbarButtonSize: "medium",
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      uploader: {
        insertImageAsBase64URI: true,
      },
      controls: {
        font: {
          command: "fontname",
          list: {
            "'Open Sans',sans-serif": "Open Sans",
            "Helvetica,sans-serif": "Helvetica",
            "Arial,Helvetica,sans-serif": "Arial",
            "Georgia,serif": "Georgia",
            "Impact,Charcoal,sans-serif": "Impact",
            "Tahoma,Geneva,sans-serif": "Tahoma",
            "'Times New Roman',Times,serif": "Times New Roman",
            "Verdana,Geneva,sans-serif": "Verdana",
            "Consolas,monaco,monospace": "Consolas",
          },
        },
      },
    }),
    []
  );

  const [formData, setFormData] = useState({
    title: "",
    id: id,
    description: "",
    price: "",
    heightInch: [],
    heightInchValue: [],
    bodyShape: [],
    bodyShapeValue: [],
    styleIdentity: [],
    styleIdentityValue: [],
    flauntParts: [],
    flauntPartsValue: [],
    downplayParts: [],
    downplayPartsValue: [],
    brand: "",
    brandId: "",
    categoryId: "",
    color: {},
    category: "",
    images: [],
  });
  console.log(formData.color, "color")
  // const categoryList = [
  //   { _id: "1", name: "Tops" },
  //   { _id: "2", name: "Bottoms" },
  //   { _id: "3", name: "Dresses" },
  //   { _id: "4", name: "Shoes" },
  //   { _id: "5", name: "Accessories" },
  //   { _id: "6", name: "Jewelry" },
  //   { _id: "7", name: "Jumpsuits" },
  // ];
  // console.log(formData, "formData")
  const [brandList, setBrandList] = useState([])
  const [errors, setErrors] = useState({});
  console.log("product errr:", errors)
  const { imageFileRegex } = regex;
  const styleIdentityArray = [
    { value: "Bold Boss", label: "Bold Boss" },
    { value: "Dreamy Diva", label: "Dreamy Diva" },
    { value: "Timeless Queen", label: "Timeless Queen" },
    { value: "Effortless Chic", label: "Effortless Chic" },
  ];
  const handleStyleIdentity = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      styleIdentity: selectedOptions.map((option) => option.value),
      styleIdentityValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, styleIdentityValue: null }));
  };
  const fetchProductDetails = async () => {
    try {
      const { data } = await productDetailApi(id);
      const product = data?.data?.product || {};
      console.log('product', product)
      setSelectedOptions({
        ...multiSelectValueHandler(product),
        category: product.category || "",
        brand: product.brand?._id || "",
        colorName: product.color || {}
      });


      setFormData({
        id: id,
        images: product.images || [],
        title: product.title || "",
        description: product.description || "",
        price: product.price || "",

        // heightInch: product.height || [],
        // heightInchValue: product.height?.map((value) =>
        //   heightArray.find((item) => item.value === value)
        // ) || [],
        // bodyShape: product.bodyShape || [],
        // bodyShapeValue: product.bodyShape?.map((value) =>
        //   bodyShapeArray.find((item) => item.value === value)
        // ) || [],

        // styleIdentity: product.styleIdentity || [],
        // styleIdentityValue: product?.styleIdentity?.map((value) =>
        //   styleIdentityArray.find((item) => item.value === value)
        // ) || [], flauntParts: product.flauntParts || [],
        // flauntPartsValue: product.flauntParts?.map((value) =>
        //   downplayArray.find((item) => item.value === value)
        // ) || [],

        // downplayParts: product.downplayParts || [],
        // downplayPartsValue: product.downplayParts?.map((value) =>
        //   downplayArray.find((item) => item.value === value)
        // ) || [],
        // brand: product.brand?._id || "",
        // category: product.category || "",
        // color: product.color || {},
        // productId: product.productId || "",
        stockQuantity: product.quantity || "",
      });
      setAvailableSizes(product.sizes)
      setPaletteName(product.paletteName)
      setOccasionName(product.occasion)
      // setSizeType(product?.category)

      const category = product?.category;

      if (category === "Shoes") {
        setSizeType("shoes");
        setShowSize(false);
      } else if (["Tops", "Bottoms", "Outerwear", "Jumpsuits", "Dresses"].includes(category)) {
        setSizeType("clothes");
        setShowSize(false);
      } else {
        setSizeType(category?.toLowerCase() || ""); // Optional default
        setShowSize(true); // Or false depending on your logic
      }
    } catch (error) {
      toastMessage(error.message, "error", "ProductDetails");
    }
  };

  // console.log(selectedOptions, "selected options---->")

  useEffect(() => {
    fetchProductDetails();
  }, [id]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "category") {
      if (value === "Shoes") {
        setSizeType("shoes")
        setShowSize(false)

      } else if (["Tops", "Bottoms", "Outerwear", "Jumpsuits", "Dresses"].includes(value)) {
        setSizeType("clothes")
        setShowSize(false)

      } else if (["Accessories", "Jewelry"].includes(value)) {
        setShowSize(true)
      }
      sizeListHandler()
    }
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevData) => ({ ...prevData, [name]: null }));

  };
  const removeImage = (indexToRemove, id) => {
    setFormData((prevData) => {
      const updatedImages = [...prevData?.images];
      const removedImage = updatedImages?.splice(indexToRemove, 1);
      const updatedRemoveIds = id
        ? [...(prevData?.removeId || []), id]
        : [...(prevData?.removeId || [])];

      return {
        ...prevData,
        images: updatedImages,
        removeImages: [...(prevData?.removeImages || []), ...removedImage],
        removeId: updatedRemoveIds,
      };
    });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validImages = files.filter((file) => imageFileRegex.test(file.name));
    if (validImages?.length > 0) {
      const imagePreviews = validImages.map((file) =>
        URL.createObjectURL(file)
      );
      setFormData((prevData) => ({
        ...prevData,
        images: [...prevData?.images, ...validImages],
        removeImages: prevData.removeImages?.filter(
          (img) => !validImages.includes(img)
        ),
      }));
    }
    setErrors((prevData) => ({ ...prevData, images: null }));

  }
  // console.log(formData, "formData")
  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.price) newErrors.price = "Price is required";
    if (!formData.stockQuantity)
      newErrors.stockQuantity = "Stack quantity is required";


    if (selectedOptions?.height?.length === 0)
      newErrors.height = "Height is required";
    if (selectedOptions?.paletteName?.length === 0)
      newErrors.paletteName = "Palette Name is required";

    // if (selectedOptions?.styleIdentity?.length === 0)
    //   newErrors.styleIdentity = "style identity is required";

    if (selectedOptions?.flauntParts?.length === 0)
      newErrors.flauntParts = "Flaunt parts is required";
    if (selectedOptions?.downplayParts?.length === 0)
      newErrors.downplayParts = "Downplay parts is required";
    if (selectedOptions?.occasionName?.length === 0)
      newErrors.occasionName = "Occasion name is required";
    if (selectedOptions?.category?.length === 0)
      newErrors.category = "Category name is required";
    if (selectedOptions?.brand?.length === 0)
      newErrors.brand = "Brand name is required";
    if (selectedOptions?.colorName?.length === 0)
      newErrors.colorName = "color name is required";

    if (!formData.description)
      newErrors.description = "Description is required";
    if (formData.images.length === 0)
      newErrors.images = "At least one image is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    try {
      let payLoad = {
        paletteName: selectedOptions.paletteName?.map((item) => item.value),
        occasion: selectedOptions.occasionName?.map((item) => item.value),
        categoryId: selectedOptions.category,
        color: selectedOptions.colorName,
        brandId: selectedOptions.brand,
        bodyShape: selectedOptions.bodyShape?.map((item) => item.value),
        styleIdentity: selectedOptions.styleIdentity?.map((item) => item.value),
        flauntParts: selectedOptions.flauntParts?.map((item) => item.value),
        downplayParts: selectedOptions.downplayParts?.map((item) => item.value),
        height: selectedOptions.height?.map((item) => item.value),
        sizes: selectedOptions.availableSizes?.map((item) => item.value),
      };
      const formDatas = new FormData();
      formDatas.append("productId", formData.id);
      formDatas.append("title", formData.title);
      formDatas.append("price", formData.price);
      formDatas.append("quantity", formData.stockQuantity);
      formDatas.append("description", formData.description);
      formDatas.append("color", JSON.stringify(payLoad.color));
      formDatas.append("height", JSON.stringify(payLoad.height));
      formDatas.append("bodyShape", JSON.stringify(payLoad.bodyShape));
      formDatas.append("styleIdentity", JSON.stringify(payLoad.styleIdentity));
      formDatas.append("flauntParts", JSON.stringify(payLoad.flauntParts));
      formDatas.append("downplayParts", JSON.stringify(payLoad.downplayParts));
      formDatas.append("brandId", payLoad.brandId);
      formDatas.append("categoryId", payLoad.categoryId);
      formDatas.append("sizes", JSON.stringify(payLoad.sizes));
      formDatas.append("paletteName", JSON.stringify(payLoad.paletteName));
      formDatas.append("occasion", JSON.stringify(payLoad.occasion));
      const res = await editProductApi(formDatas);
      if (res?.status === 200) {
        toastMessage(res?.data?.message, "success", "EditProduct");
        navigate(-1);
      }
    } catch (error) {
      toastMessage(error.message, "error", "EditProduct");
    } finally {
      setIsLoading(false);
    }
  };

  const bodyShapeArray = [
    { value: "Round", label: "Round" },
    { value: "Triangle", label: "Triangle" },
    { value: "Hourglass", label: "Hourglass" },
    { value: "Rectangle", label: "Rectangle" },
    { value: "Inverted Triangle", label: "Inverted Triangle" },
  ];
  const handleBodyShape = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      bodyShape: selectedOptions.map((option) => option.value),
      bodyShapeValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, bodyShapeValue: null }));
  };
  const handleflauntParts = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      flauntParts: selectedOptions.map((option) => option.value),
      flauntPartsValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, flauntPartsValue: null }));
  };
  const handleHeight = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      heightInch: selectedOptions.map((option) => option.value),
      heightInchValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, heightInchValue: null }));
  };
  const handledownplayParts = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      downplayParts: selectedOptions.map((option) => option.value),
      downplayPartsValue: selectedOptions,
    }));
    setErrors((prevData) => ({ ...prevData, downplayPartsValue: null }));

  };
  const downplayArray = [
    { value: "Neckline", label: "Neckline" },
    { value: "Waist", label: "Waist" },
    { value: "Legs", label: "Legs" },
    { value: "Arms", label: "Arms" },
    { value: "Back", label: "Back" },
    { value: "Buttocks", label: "Buttocks" },
  ];
  const heightArray = [

    { value: "Average", label: "Average" },
    { value: "Tall", label: "Tall" },
    { value: "Petite", label: "Petite" },

  ];
  const sizeOptions = [
    { value: "XS", label: "XS" },
    { value: "S", label: "S" },
    { value: "M", label: "M" },
    { value: "L", label: "L" },
    { value: "XL", label: "XL" },
  ];
  const paletteOptions = [
    { value: "Bright Spring", label: "Bright Spring" },
    { value: "Bright Winter", label: "Bright Winter" },
    { value: "Dark Autumn", label: "Dark Autumn" },
    { value: "Dark Winter", label: "Dark Winter" },
    { value: "Light Spring", label: "Light Spring" },
    { value: "Light Summer", label: "Light Summer" },
    { value: "Soft Autumn", label: "Soft Autumn" },
    { value: "Soft Summer", label: "Soft Summer" },
    { value: "True Autumn", label: "True Autumn" },
    { value: "True Spring", label: "True Spring" },
    { value: "True Summer", label: "True Summer" },
    { value: "True Winter", label: "True Winter" },
  ];
  const colorListHandler = async () => {
    try {
      const res = await masterColorApi();
      if (res?.data?.status === 200) {
        setColorList(res.data?.data?.colors);
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      toastMessage(e.message, "error", "categoryList");
    }
  };
  // const categoryListHandler = async () => {
  //   try {
  //     const res = await masterCategoriesListApi();
  //     if (res?.data?.status === 200) {
  //       setCategoryList(res.data?.data?.categories);
  //     } else {
  //       toastMessage(res?.data?.message, "error", "categoryList");
  //     }
  //   } catch (e) {
  //     toastMessage(e.message, "error", "categoryList");
  //   }
  // };
  const brandListHandler = async () => {
    try {
      const res = await masterBrandListApi();
      if (res?.data?.status === 200) {
        setBrandList(res.data?.data?.brands);
      } else {
        toastMessage(res?.data?.message, "error", "brand");
      }
    } catch (e) {
      toastMessage(e.message, "error", "brand");
    }
  };
  const sizeListHandler = async (type = sizeType) => {
    try {
      const res = await masterSizeApi({ type });

      if (res?.data?.status === 200) {
        const sizeOptions = res.data?.data?.sizes.map((size) => ({
          value: size.name,
          label: size.name,
        }));
        setSizeList(sizeOptions);
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      toastMessage(e.message, "error", "categoryList");
    }
  };

  const categoryListHandler = async () => {
    try {
      const res = await masterClothingCategoriesListApi();

      if (res?.data?.status === 200) {
        setCategoryList(res.data?.data?.categories);
      } else {
        toastMessage(res?.data?.message, "error", "categoryList");
      }
    } catch (e) {
      toastMessage(e.message, "error", "categoryList");
    }
  };

  const multiSelectValueHandler = (projectObject) => {
    const extractValue = [
      "height",
      "paletteName",
      "bodyShape",
      "styleIdentity",
      "flauntParts",
      "downplayParts",
      "occasionName",
      "availableSizes",
    ];

    const dummySelectedValue = {};

    extractValue.forEach((key) => {
      if (key === "occasionName") {
        dummySelectedValue["occasionName"] = projectObject["occasion"].map((item) => ({ value: item, label: item }));
      } else if (key === "availableSizes") {
        dummySelectedValue["availableSizes"] = projectObject["sizes"].map((item) => ({ value: item, label: item }));
      } else if (Array.isArray(projectObject[key])) {
        dummySelectedValue[key] = projectObject[key].map((item) => ({ value: item, label: item }));
      } else {
        dummySelectedValue[key] = [];
      }
    });
    return dummySelectedValue
  };


  useEffect(() => {
    categoryListHandler()
    colorListHandler()
    brandListHandler()
  }, []);
  useEffect(() => {

    sizeListHandler()
  }, [sizeType]);
  return (
    <div className="editProduct">
      <div className="dashboard_title has_child">
        <h3>
          <Link to={`/product-management/exclusive`}>
            <IoMdArrowRoundBack />
          </Link>
          Edit Product
        </h3>
        <CustomButton onClick={handleSubmit} isLoading={isLoading}>
          Update
        </CustomButton>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Title<Star /></label>
                <Input
                  type="text"
                  // label="Title"
                  name="title"
                  placeholder="Enter Title"
                  value={formData.title}
                  onChange={handleInputChange}
                  error={errors.title}
                />
              </div>
              <div className="form_field">
                <label className="label">Price<Star /></label>
                <Input
                  type="number"
                  // label="Price"
                  name="price"
                  placeholder="Enter Price"
                  value={formData.price}
                  onChange={handleInputChange}
                  error={errors.price}
                />
              </div>
              {/* <div className="form_field">
                <label className="label">
                  Category<Star />
                </label>
                <select
                  className="input form-control"
                  type="text"
                  value={formData.category || ""}
                  name="category"
                  error={errors.category}
                  onChange={handleInputChange}
                >
                  <option value={""}>Select Category</option>
                  {categoryList.map((data) => (
                    <option key={data._id} value={data.name}>
                      {data.name}
                    </option>
                  ))}
                </select>
                {errors && <div className="text-danger">{errors.category}</div>}

              </div> */}
            </div>


            {/* <div className="form_field_wrap"> */}

            {/* <div className="form_field">
                <label className="label">Available Sizes<Star /></label>
                <Select
                  className="multi-select"
                  isMulti
                  isDisabled={showSize}
                  options={sizeList}
                  value={sizeList.filter((size) => availableSizes.includes(size.value))}
                  onChange={handleSizeChange}
                />
                {errors && <div className="text-danger">{errors.availableSizes}</div>}

              </div> */}
            <div className="form_field">
              <label className="label">Stock Quantity<Star /></label>
              <Input
                type="number"
                // label="Stock Quantity"
                name="stockQuantity"
                placeholder="Enter Stock Quantity"
                value={formData.stockQuantity}
                onChange={handleInputChange}
                error={errors.stockQuantity}
              />
            </div>
            <Form {...{ selectedOptions, setSelectedOptions, errors, setErrors, sizeType, setSizeType }} />
            {/* </div> */}
            {/* <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">
                  Height<Star />
                </label>
                <Select
                  placeholder={<div>Select Height</div>}
                  name="select"
                  className="multi_select multi-select"
                  value={formData.heightInchValue}
                  options={heightArray}
                  isMulti
                  onChange={handleHeight}
                />
                {errors && <div className="text-danger">{errors.heightInchValue}</div>}
              </div>
              <div className="form_field">
                <label className="label">Body Shape<Star /></label>

                <Select
                  placeholder={<div>Select Body Shape </div>}
                  name="select"

                  className="multi_select multi-select"
                  value={formData.bodyShapeValue}
                  options={bodyShapeArray}
                  isMulti
                  onChange={handleBodyShape}
                />
                {errors && (
                  <div className="text-danger">{errors.bodyShapeValue}</div>
                )}

              </div>
            </div> */}

            {/* <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Style Identity</label>
                <Select
                  placeholder={<div>Select Style Identity</div>}
                  name="select"

                  className="multi_select multi-select"
                  value={formData.styleIdentityValue}
                  options={styleIdentityArray}
                  isMulti
                  onChange={handleStyleIdentity}
                />
                {errors && (
                  <div className="text-danger">{errors.styleIdentityValue}</div>
                )}
              </div>
              <div className="form_field">
                <label className="label">
                  Flaunt Parts<Star />
                </label>
                <Select
                  placeholder={<div>Select Flaunt Parts</div>}
                  name="select"
                  className="multi_select multi_select"
                  value={formData.flauntPartsValue}
                  options={downplayArray}
                  isMulti
                  onChange={handleflauntParts}
                />
                {errors && <div className="text-danger">{errors.flauntPartsValue}</div>}

              </div>
            </div> */}
            {/* <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Downplay Parts<Star /></label>
                <Select
                  placeholder={<div>Select Downplay Parts</div>}
                  name="select"
                  className="multi_select multi-select"
                  value={formData.downplayPartsValue}
                  options={downplayArray}
                  isMulti
                  onChange={handledownplayParts}
                />
                {errors && <div className="text-danger">{errors.downplayPartsValue}</div>}
              </div>
              <div className="form_field">
                <label className="label">Palette Name<Star /></label>
                <Select
                  className="multi-select"
                  isMulti
                  options={paletteOptions}
                  value={paletteOptions.filter((palette) => paletteName.includes(palette.value))}
                  onChange={handlePaletteChange}
                />
                {errors && <div className="text-danger">{errors.paletteName}</div>}
              </div>

             
            </div> */}
            {/* <div className="form_field_wrap">

              <div className="form_field">
                <label className="label">Occasion Name<Star /></label>
                <Select
                  className="multi-select"
                  isMulti
                  options={occasionArray}
                  value={occasionArray.filter((occasion) =>
                    occasionName.includes(occasion.value)
                  )}
                  onChange={handleOccasionChange}
                />
                {errors && (
                  <div className="text-danger">{errors.occasionName}</div>
                )}
              </div>
              <div className="form_field">
                <label className="label">Color Name<Star /></label>
                <select
                  className="input form-control"
                  value={JSON.stringify(formData.color) || ""}
                  name="color"
                  onChange={(e) => {
                    const selectedColor = JSON.parse(e.target.value);
                    setFormData({ ...formData, color: selectedColor });
                  }}
                >
                  <option value="">Select Color</option>
                  {colorList.map((data) => (
                    <option
                      key={data._id}
                      value={JSON.stringify({ name: data.name, hexCode: data.hexCode })} // Stringify the object
                    >
                      {data.name}
                    </option>
                  ))}
                </select>
                {errors && <div className="text-danger">{errors.color}</div>}
              </div>

            </div> */}
            <div className="form_field_wrap">
              <div className="form_field">
                <label className="label">Description<Star /></label>
                <JoditEditor
                  ref={editor}
                  value={formData.description}
                  config={config}
                  tabIndex={1}
                  onBlur={(newContent) => {
                    setFormData((prevData) => ({ ...prevData, description: newContent }));
                    setErrors((prevData) => ({ ...prevData, description: null }));
                  }}
                />
                {errors && <div className="text-danger">{errors.description}</div>}
              </div>
              <div className="form_field">
                <label className="label">Upload Images<Star /></label>
                <div className="upload_button_wrap">
                  <label htmlFor="upload_images" className="upload_button input">
                    <IoCloudUploadOutline className="icon" />
                    <input
                      type="file"
                      multiple
                      accept="image/*"
                      onChange={handleFileChange}
                      id="upload_images"
                    />
                    <span className="text">Select file to upload</span>
                  </label>
                  {errors && <div className="text-danger">{errors.images}</div>}
                  <div className="image_preview_wrap">
                    {formData.images?.map((image, index) => (
                      <div className="image_preview" key={index}>
                        <img src={image.url ? image.url : URL.createObjectURL(image)} alt="Preview" width="100" />
                        <button
                          type="button"
                          className="remove_image_button"
                          onClick={() => removeImage(index, image?._id)}
                        >
                          <GoX />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditProduct;
